module.exports = __webpack_public_path__ + "static/media/game-pass.d2b413a9.svg";